import { useLocation } from "react-router-dom";

export default function useQuery() {
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  return { pathname, search, searchParams };
}
